import axios from 'axios'

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
})

export const storageKey = 'TRACKER:userData'

const storageUserData = localStorage.getItem(storageKey)

if (storageUserData) {
  const { access_token } = JSON.parse(storageUserData)
  api.defaults.headers.Authorization = `Bearer ${access_token}`
}

export default api